<template>
  <v-data-table
    style="background: transparent;"
    :headers="headers"
    :items="dsnList"
    hide-default-footer
    :loading="loading"
    id="table_dns"
    mobile-breakpoint=""
  >
    <template
      v-if="dsnList.length"
      #body="{ items }"
    >
      <tbody>
        <tr
          v-for="(item, index) in items"
          :key="index"
        >
          <td>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </td>
          <td>
            <v-row no-gutters justify="end">
              <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-btn icon v-on="on" @click="deleteAddr(item)">
                    <v-icon>
                      delete
                    </v-icon>
                  </v-btn>
                </template>
                <span>Tooltip</span>
              </v-tooltip>
            </v-row>
          </td>
        </tr>
      </tbody>
    </template>
    <template v-else>
      <td>
        {{ $t('$vuetify.noDataText') }}
      </td>
    </template>
  </v-data-table>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
      loading: false,
      headers: [
        {
          text: this.$tc('ip'),
          align: 'start',
          value: 'name'
        },
        {
          text: this.$tc('action', 2),
          align: 'right',
          sortable: false,
          value: null
        }
      ]
    }
  },
  computed: {
    p11Info () {
      return this.$store.state.hsm.p11Info
    },
    dsnList () {
      const dsnList = []

      if (this.p11Info.dns1 !== '') {
        dsnList.push(this.p11Info.dns1)
      }

      if (this.p11Info.dns2 !== '') {
        dsnList.push(this.p11Info.dns2)
      }

      return dsnList
    }
  },
  methods: {
    deleteAddr (addr) {
      this.$emit('deleteAddr', { addr })
    }
  }
}
</script>
